import React, { useEffect, useRef } from "react";
import PointInfo from "./PointInfo";
import MenuCustomer from "./MenuCustomer";
const TopCoupon = ({ custName = "dev test", point, expiredDate, expiredPoint, profileImg, rank }) => {
    const btnMenuRef = useRef(null);
    rank = `${rank}`.toLowerCase()
    
    return (
        <>
            <section id="pTopcard-profile">
                <div class="bTopcard">

                    <div class="bTopProfile">
                        <div class="bDisplay">
                            <div class="bPic">
                                <img src={profileImg} alt="" />
                            </div>
                            <h2>{custName}</h2>
                            <span data-tier={`${rank}`}></span>
                        </div>
                        <PointInfo point={point} expiredDate={expiredDate} expiredPoint={expiredPoint}/>
                    </div>
                    <a id="btnMenu" ref={btnMenuRef}><span></span></a>
                </div>
            </section>
            <MenuCustomer btnMenuRef={btnMenuRef}/>
        </>
    )
}

export default TopCoupon
